import React, { useState } from "react";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Box,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";

function ClosedRemarkList({ closedRemarkData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [searchQuery, setSearchQuery] = useState(""); // Search query

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page
  };

  // Filter data based on search query
  const filteredData = closedRemarkData.filter((data) => {
    const searchValue = searchQuery.toLowerCase();
    return (
      data.Lot_Number?.toLowerCase().includes(searchValue) ||
      data.Farmer_Name?.toLowerCase().includes(searchValue) ||
      data.Branch_Name?.toLowerCase().includes(searchValue) ||
      data.Zone_Name?.toLowerCase().includes(searchValue) ||
      data.AGE?.toString().includes(searchValue) ||
      data.BWT?.toString().includes(searchValue) ||
      data.M_QTY?.toString().includes(searchValue) ||
      data.REASON?.toLowerCase().includes(searchValue) ||
      data.agent_name?.toLowerCase().includes(searchValue) ||
      data.closure_status?.toLowerCase().includes(searchValue) ||
      data.REMARKS?.toLowerCase().includes(searchValue)
    );
  });

  return (
    <>
      <Paper>
        {/* Search Input */}
        
          <TextField
            label="Search"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{ marginBottom: 2, margin: 1, float: 'right' }}
          />
        

        {/* Table */}
        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "16px 0",
          }}
        >
          <Table
            sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell align="center" sx={{ width: 50 }}>
                  Sno
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Lot Number
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Farmer Name
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Branch Name
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Zone Name
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Age
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Body Weight
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Mortality Quantity
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Reason
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Agent Name
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Closure Status
                </TableCell>
                <TableCell align="center" sx={{ width: 150 }}>
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(filteredData) && filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No Data Available Yet.
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((data, index) => (
                    <TableRow key={data?.id || index}>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.Lot_Number || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.Farmer_Name || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.Branch_Name || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.Zone_Name || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.AGE || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.BWT || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.M_QTY || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.REASON || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        {data?.agent_name || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        <Chip
                          label={data.closure_status}
                          color={"success"}
                          size="small"
                          sx={{ textTransform: "capitalize", margin: "5px" }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                        <LongTextComponent
                          text={(data?.REMARKS === null || data?.REMARKS === undefined) ? "-" : data.REMARKS}
                          maxLength={20}
                        />
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={Array.isArray(filteredData) ? filteredData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default ClosedRemarkList;
